import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

/**
 * RAG (Red/Amber/Green) overview cards, one per CAM category. Clicking a card
 * opens + scrolls to that category's parameter section.
 */
const CamCategoryOverview = ({ categories, onSelect }) => (
    <div className={"cc-cam-overview"}>
        {categories.map(cat => {
            const pct = cat.total
                ? Math.round((cat.passed / cat.total) * 100)
                : 0;
            const tone = cat.statusKey.toLowerCase();
            return (
                <button
                    type={"button"}
                    key={cat.title}
                    className={"cc-cam-ovcard cc-cam-ovcard--" + tone}
                    onClick={() => onSelect && onSelect(cat.title)}
                    title={`Go to ${cat.title}`}
                >
                    <span className={"cc-cam-ovcard__icon"}>
                        <Icon type={cat.icon} />
                    </span>
                    <span className={"cc-cam-ovcard__body"}>
                        <span className={"cc-cam-ovcard__title"}>
                            {cat.title}
                        </span>
                        <span className={"cc-cam-ovcard__meta"}>
                            <span className={"cc-cam-ovcard__status"}>
                                {cat.statusKey}
                            </span>
                            <span className={"cc-cam-ovcard__count"}>
                                {cat.passed}/{cat.total} Pass
                            </span>
                        </span>
                        <span className={"cc-cam-ovcard__track"}>
                            <span
                                className={"cc-cam-ovcard__fill"}
                                style={{ width: `${pct}%` }}
                            />
                        </span>
                    </span>
                </button>
            );
        })}
    </div>
);

CamCategoryOverview.propTypes = {
    categories: PropTypes.array.isRequired,
    onSelect: PropTypes.func
};

export default CamCategoryOverview;
